import { render } from "./ClientHeader.vue?vue&type=template&id=5fa25039&scoped=true"
import script from "./ClientHeader.vue?vue&type=script&lang=ts"
export * from "./ClientHeader.vue?vue&type=script&lang=ts"

import "./ClientHeader.vue?vue&type=style&index=0&id=5fa25039&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5fa25039"

export default script